import Icon from '@commons/components/Icon';
import Quote from '@commons/components/Quote';
import RichText from '@commons/components/RichText';
import Text from '@commons/components/Text';
import Flex from '@commons/containers/Flex';

import type { TestimonialNodeProps } from '.';
import styles from './Featured.module.scss';

/**
 * Testimonial node component for the Featured display type.
 */

const TestimonialNodeFeatured = (props: TestimonialNodeProps) => {
  const { quote, name, position } = props;

  return (
    <Flex
      gap="lg"
      width={12}
      align="stretch"
      direction={{ xs: 'column', md: 'row' }}
      className={styles.testimonial}
    >
      <Flex width={{ xs: 12, md: 6 }} align="center" justify={{ xs: 'start', md: 'center' }}>
        <Icon type="quote" className={styles.icon} />
      </Flex>
      <Quote width={{ xs: 12, md: 6 }}>
        <RichText value={quote} marginBottom="sm" />
        {name && (
          <Text level="body-xs" weight="semibold" transform="uppercase" marginBottom={4}>
            {name}
          </Text>
        )}
        {position && (
          <Text
            level="body-xs"
            weight="semibold"
            transform="uppercase"
            marginBottom="none"
            className={styles.position}
          >
            {position}
          </Text>
        )}
      </Quote>
    </Flex>
  );
};

export default TestimonialNodeFeatured;
